import { AxiosResponse } from 'axios';
import { getRequest } from '../base';

export interface RDotMatrixPrint {
  storeName: string;
  storeContact: string;
  storeAddress: string;
  gstin: string;
  drugLic: string;
  invoiceNo: string;
  invoiceTitle: string;
  invoiceDate: string;
  customerName: string;
  customerContact: string;
  customerAddress: string;
  doctorName: string;
  doctorContact: string;
  doctorAddress: string;
  printTermsMsg: string;
  printCompositionMsg: string;
  isCompositionBill: boolean;
  dotMatrixItemPerPage: number;
  items: {
    name: string;
    manufacturer: string;
    batchNo: string;
    expiry: number;
    billQty: number;
    price: number;
    mrp: number;
    netItemAmount: number;
    packaging: string;
  }[];
  cgst: string;
  sgst: string;
  totalGst: string;
  totalMrp: string;
  totalSaving: string;
  netAmount: string;
}

export const PrintService = {
  getDotMatrixData: async (
    id: string,
  ): Promise<AxiosResponse<{ data: { data: RDotMatrixPrint } }>> =>
    getRequest(`get_dot_matrix_bill/${id}`),
};
